import { render, staticRenderFns } from "./Signals.vue?vue&type=template&id=534cad71&"
import script from "./Signals.vue?vue&type=script&lang=js&"
export * from "./Signals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports